import { render, staticRenderFns } from "./seckillPrice.vue?vue&type=template&id=9fb54e62&scoped=true&"
import script from "./seckillPrice.vue?vue&type=script&lang=js&"
export * from "./seckillPrice.vue?vue&type=script&lang=js&"
import style0 from "./seckillPrice.vue?vue&type=style&index=0&id=9fb54e62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb54e62",
  null
  
)

export default component.exports